// Updated Dashboard.jsx - Now properly delegates to UserDashboard
import React from 'react';
import UserDashboard from './UserDashboard.jsx';

const Dashboard = ({ initialView = 'dashboard' }) => {
  // For now, always show UserDashboard
  // Later we can add view switching if needed
  return <UserDashboard />;
};

export default Dashboard;